import {
  ADMIN_COLLECTION_CREATE_REQUEST,
  ADMIN_COLLECTION_CREATE_FAIL,
  ADMIN_COLLECTION_CREATE_SUCCESS,
  ADMIN_COLLECTION_CREATE_RESET,
  ADMIN_COLLECTION_LIST_REQUEST,
  ADMIN_COLLECTION_LIST_FAIL,
  ADMIN_COLLECTION_LIST_SUCCESS,
  ADMIN_COLLECTION_SEARCH_REQUEST,
  ADMIN_COLLECTION_SEARCH_FAIL,
  ADMIN_COLLECTION_SEARCH_SUCCESS,
  ADMIN_COLLECTION_VIEW_REQUEST,
  ADMIN_COLLECTION_VIEW_FAIL,
  ADMIN_COLLECTION_VIEW_SUCCESS,
  ADMIN_COLLECTION_DELETE_REQUEST,
  ADMIN_COLLECTION_DELETE_FAIL,
  ADMIN_COLLECTION_DELETE_SUCCESS,
  ADMIN_COLLECTION_UPDATE_REQUEST,
  ADMIN_COLLECTION_UPDATE_FAIL,
  ADMIN_COLLECTION_UPDATE_SUCCESS,
  ADMIN_COLLECTION_UPDATE_RESET,
  ADMIN_ADD_PRODUCT_COLLECTION_REQUEST,
  ADMIN_ADD_PRODUCT_COLLECTION_SUCCESS,
  ADMIN_ADD_PRODUCT_COLLECTION_FAIL,
  ADMIN_ADD_PRODUCTS_COLLECTION_REQUEST,
  ADMIN_ADD_PRODUCTS_COLLECTION_SUCCESS,
  ADMIN_ADD_PRODUCTS_COLLECTION_FAIL,
  ADMIN_REMOVE_PRODUCT_COLLECTION_REQUEST,
  ADMIN_REMOVE_PRODUCT_COLLECTION_SUCCESS,
  ADMIN_REMOVE_PRODUCT_COLLECTION_FAIL,
  ADMIN_REMOVE_PRODUCTS_COLLECTION_REQUEST,
  ADMIN_REMOVE_PRODUCTS_COLLECTION_SUCCESS,
  ADMIN_REMOVE_PRODUCTS_COLLECTION_FAIL,
  ADMIN_ADD_PRODUCTSIDS_COLLECTION_FAIL,
  ADMIN_ADD_PRODUCTSIDS_COLLECTION_REQUEST,
  ADMIN_ADD_PRODUCTSIDS_COLLECTION_SUCCESS,
  ADMIN_ADD_PRODUCTSIDS_COLLECTION_SUCCESS_RESET,
  ADMIN_REMOVE_ALL_PRODUCT_COLLECTION_FAIL,
  ADMIN_REMOVE_ALL_PRODUCT_COLLECTION_REQUEST,
  ADMIN_REMOVE_ALL_PRODUCT_COLLECTION_SUCCESS,
} from "./collectionTypes";

export const collectionReducer = (state = { loading: true, collections: [] }, action) => {
  switch (action.type) {
    // REQUEST
    case ADMIN_COLLECTION_CREATE_REQUEST:
      return { ...state, loading: true };

    case ADMIN_COLLECTION_LIST_REQUEST:
      return { ...state, loading: true };

    case ADMIN_COLLECTION_SEARCH_REQUEST:
      return { ...state, loading: true };

    case ADMIN_COLLECTION_VIEW_REQUEST:
      return { ...state, loading: true };

    case ADMIN_ADD_PRODUCT_COLLECTION_REQUEST:
      return { ...state, loading: true };

    case ADMIN_COLLECTION_DELETE_REQUEST:
      return { ...state, loading: true };

    case ADMIN_COLLECTION_UPDATE_REQUEST:
      return { ...state, loading: true };

    case ADMIN_REMOVE_PRODUCT_COLLECTION_REQUEST:
      return { ...state, removeLoader: true, success: true };

    case ADMIN_REMOVE_ALL_PRODUCT_COLLECTION_REQUEST:
      return {
        ...state,
        loading: false,
        success: false,
      };
    // LIST
    case ADMIN_COLLECTION_CREATE_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        singleCollection: action.payload,
      };
    case ADMIN_COLLECTION_CREATE_RESET:
      return {
        ...state,
        loading: false,
        singleCollection: {},
        success: false,
      };
    case ADMIN_COLLECTION_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        collections: action.payload.collections,
      };
    case ADMIN_COLLECTION_SEARCH_SUCCESS:
      return {
        ...state,
        loading: false,
        collections: action.payload,
      };
    case ADMIN_COLLECTION_VIEW_SUCCESS:
      return {
        ...state,
        loading: false,
        collection: action.payload,
      };
    case ADMIN_COLLECTION_UPDATE_SUCCESS:
      return {
        ...state,
        loading: false,
        collections: action.payload,
        updated: true,
      };
    case ADMIN_COLLECTION_UPDATE_RESET:
      return {
        ...state,
        collection: {},
        updated: false,
      };
    case ADMIN_COLLECTION_DELETE_SUCCESS:
      return {
        ...state,
        loading: false,
        message: action.payload.message,
      };
    case ADMIN_ADD_PRODUCT_COLLECTION_SUCCESS:
      return {
        ...state,
        loading: false,
        collection: action.payload,
      };
    case ADMIN_ADD_PRODUCTS_COLLECTION_SUCCESS:
      return {
        ...state,
        loading: false,
        collection: action.payload,
      };

    case ADMIN_REMOVE_ALL_PRODUCT_COLLECTION_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
      };

    case ADMIN_REMOVE_PRODUCT_COLLECTION_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        removeLoader: false,
        collection: action.payload,
      };
    case ADMIN_ADD_PRODUCTS_COLLECTION_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case ADMIN_REMOVE_PRODUCTS_COLLECTION_SUCCESS:
      return {
        ...state,
        loading: false,
        collection: action.payload,
      };
    case ADMIN_REMOVE_PRODUCTS_COLLECTION_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case ADMIN_ADD_PRODUCTSIDS_COLLECTION_REQUEST:
      return {
        ...state,
        loading: false,
        success: false,
      };
    case ADMIN_ADD_PRODUCTSIDS_COLLECTION_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
      };

    case ADMIN_ADD_PRODUCTSIDS_COLLECTION_SUCCESS_RESET:
      return {
        ...state,
        success: false,
      };

    case ADMIN_ADD_PRODUCTSIDS_COLLECTION_FAIL:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.payload,
      };

    case ADMIN_REMOVE_ALL_PRODUCT_COLLECTION_FAIL:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.payload,
      };
    // FAILED
    case ADMIN_COLLECTION_CREATE_FAIL ||
      ADMIN_COLLECTION_LIST_FAIL ||
      ADMIN_COLLECTION_VIEW_FAIL ||
      ADMIN_ADD_PRODUCT_COLLECTION_FAIL ||
      ADMIN_REMOVE_PRODUCT_COLLECTION_FAIL ||
      ADMIN_COLLECTION_DELETE_FAIL ||
      ADMIN_COLLECTION_UPDATE_FAIL:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};
